import Axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

class HTTP {
  constructor(options = {}) {
    this._handler = null
    this._requestMiddlewares = []
    this.mock = null

    const methods = ['get', 'delete', 'post', 'put', 'patch', 'head', 'options']

    methods.map(method => (this[method] = this._fetch(method)))

    this.init(options)
  }

  /**
   * Initialize http instance
   * @param {Object} options options
   * @returns {HTTP}
   */
  init(options = {}) {
    this._handler = Axios.create(options)

    this.disableMock()

    return this
  }

  /**
   * Enable mock adapter
   * @param {Object} options options
   */
  enableMock(options = {}) {
    this.mock = new MockAdapter(this._handler, options)
  }

  /**
   * Disable mock adapter
   */
  disableMock() {
    this.mock = new MockAdapter()
  }

  /**
   * Add header to request
   * @param {String} key header key name
   * @param {Any} value string
   * @returns {HTTP}
   */
  addHeader(key, value) {
    this._handler.defaults.headers[key] = value

    return this
  }

  /**
   * Add header to request
   * @param {Object} header header
   * @returns {HTTP}
   */
  addHeaders(headers = {}) {
    this._handler.defaults.headers = Object.assign(
      {},
      this._handler.defaults.headers,
      headers
    )

    return this
  }

  /**
   * Set headers, remove all headers and replace this headers
   * @param {Object} headers headers
   * @returns {HTTP}
   */
  setHeaders(headers = {}) {
    this._handler.defaults.headers = headers

    return this
  }

  /**
   * Get headers
   */
  getHeaders() {
    return this._handler.defaults.headers
  }

  /**
   * Unset given header
   * @param {String} header header name
   * @returns {Boolean} ok or nok
   */
  unsetHeader(header) {
    if (this._handler.defaults.headers[header]) {
      delete this._handler.defaults.headers[header]

      return true
    }

    return false
  }

  /**
   * Add request middleware
   * @param {Function} middleware middleware
   */
  addRequestMiddleware(middleware) {
    this._requestMiddlewares.push(middleware)

    return this
  }

  /**
   * Add response middleware
   * @param {Function} middleware middleware
   */
  addResponseMiddleware(ok, err) {
    this._handler.interceptors.response.use(ok, err)

    return this
  }

  /**
   * Add transform to request
   * @param {Function} transform transform
   * @returns {HTTP}
   */
  transformRequest(transform) {
    this._options.transformRequest = transform

    return this
  }

  /**
   * Add transform to response
   * @param {Function} transform transform
   * @returns {HTTP}
   */
  transformResponse(transform) {
    this._options.transformResponse = transform

    return this
  }

  /**
   *
   * @param {string} method
   * @return {Function}
   * @private
   */
  _fetch(method) {
    return (url, { data, params, ...options } = {}) => {
      let _params = this._handler.defaults.params
      const _options = Object.assign({}, this._handler.defaults, options)

      if (params) {
        _params = Object.assign({}, _params, params)
      }

      this._requestMiddlewares.map(middleware => {
        return middleware(url, { data, params, options: _options })
      })

      return this._handler({
        method,
        url,
        data,
        params: _params,
        ..._options
      })
        .then(res => {
          return res.data
        })
        .catch(err => {
          return Promise.reject(err)
        })
        // .finally(res => {
          
        // })
    }
  }
}

export default new HTTP()
